const callPrefix = '@@KANDY/CALL/'

/**
 * Basic call operation actions.
 */
export const MAKE_CALL = callPrefix + 'MAKE'
export const PENDING_MAKE_CALL = callPrefix + 'PENDING_MAKE'
export const SESSION_CREATED = callPrefix + 'SESSION_CREATED'
export const MAKE_CALL_FINISH = callPrefix + 'MAKE_FINISH'

export const MAKE_ANONYMOUS_CALL = callPrefix + 'MAKE_ANONYMOUS_CALL'
export const MAKE_ANONYMOUS_CALL_FINISH = callPrefix + 'MAKE_ANONYMOUS_CALL_FINISH'

export const CALL_INCOMING = callPrefix + 'INCOMING'

export const SEND_RINGING_FEEDBACK = callPrefix + 'SEND_RINGING_FEEDBACK'
export const SEND_RINGING_FEEDBACK_FINISH = callPrefix + 'SEND_RINGING_FEEDBACK_FINISH'

export const CALL_RINGING = callPrefix + 'RINGING'
export const SESSION_PROGRESS = callPrefix + 'SESSION_PROGRESS'
export const CALL_CANCELLED = callPrefix + 'CANCELLED'

export const ANSWER_CALL = callPrefix + 'ANSWER'
export const ANSWER_CALL_FINISH = callPrefix + 'ANSWER_FINISH'

export const REJECT_CALL = callPrefix + 'REJECT'
export const REJECT_CALL_FINISH = callPrefix + 'REJECT_FINISH'

export const IGNORE_CALL = callPrefix + 'IGNORE'
export const IGNORE_CALL_FINISH = callPrefix + 'IGNORE_FINISH'

export const CALL_ACCEPTED = callPrefix + 'ACCEPTED'

export const END_CALL = callPrefix + 'END'
export const END_CALL_FINISH = callPrefix + 'END_FINISH'

export const FORWARD_CALL = callPrefix + 'FORWARD_CALL'
export const FORWARD_CALL_FINISH = callPrefix + 'FORWARD_CALL_FINISH'

export const PENDING_OPERATION = callPrefix + 'PENDING_OPERATION'

/**
 * Mid-call operation actions.
 */

export const UPDATE_CALL = callPrefix + 'UPDATE_CALL'

export const CALL_HOLD = callPrefix + 'HOLD'
export const CALL_HOLD_FINISH = callPrefix + 'HOLD_FINISH'

export const CALL_UNHOLD = callPrefix + 'UNHOLD'
export const CALL_UNHOLD_FINISH = callPrefix + 'UNHOLD_FINISH'

export const SET_CUSTOM_PARAMETERS = callPrefix + 'SET_CUSTOM_PARAMETERS'

export const SEND_CUSTOM_PARAMETERS = callPrefix + 'SEND_CUSTOM_PARAMETERS'
export const SEND_CUSTOM_PARAMETERS_FINISH = callPrefix + 'SEND_CUSTOM_PARAMETERS_FINISH'

export const ADD_MEDIA = callPrefix + 'ADD_MEDIA'
export const ADD_MEDIA_FINISH = callPrefix + 'ADD_MEDIA_FINISH'
export const ADD_BASIC_MEDIA = callPrefix + 'ADD_BASIC_MEDIA'

export const REMOVE_MEDIA = callPrefix + 'REMOVE_MEDIA'
export const REMOVE_MEDIA_FINISH = callPrefix + 'REMOVE_MEDIA_FINISH'
export const REMOVE_BASIC_MEDIA = callPrefix + 'REMOVE_BASIC_MEDIA'

export const MUSIC_ON_HOLD = callPrefix + 'MUSIC_ON_HOLD'

export const SEND_DTMF = callPrefix + 'SEND_DTMF'
export const SEND_DTMF_FINISH = callPrefix + 'SEND_DTMF_FINISH'

export const GET_STATS = callPrefix + 'GET_STATS'
export const GET_STATS_FINISH = callPrefix + 'GET_STATS_FINISH'

export const CONSULTATIVE_TRANSFER = callPrefix + 'CONSULTATIVE_TRANSFER'
export const PENDING_CONSULTATIVE_TRANSFER = callPrefix + 'PENDING_CONSULTATIVE_TRANSFER'
export const CONSULTATIVE_TRANSFER_FINISH = callPrefix + 'CONSULTATIVE_TRANSFER_FINISH'

export const DIRECT_TRANSFER = callPrefix + 'DIRECT_TRANSFER'
export const DIRECT_TRANSFER_FINISH = callPrefix + 'DIRECT_TRANSFER_FINISH'

export const JOIN = callPrefix + 'JOIN'
export const JOIN_START = callPrefix + 'JOIN_START'
export const PENDING_JOIN = callPrefix + 'PENDING_JOIN'
export const JOIN_FINISH = callPrefix + 'JOIN_FINISH'

export const REPLACE_TRACK = callPrefix + 'REPLACE_TRACK'
export const REPLACE_TRACK_FINISH = callPrefix + 'REPLACE_TRACK_FINISH'

export const MEDIA_RESTART = callPrefix + 'MEDIA_RESTART'
export const MEDIA_RESTART_FINISH = callPrefix + 'MEDIA_RESTART_FINISH'

export const RESYNC = callPrefix + 'RESYNC'
export const RESYNC_FINISH = callPrefix + 'RESYNC_FINISH'

/**
 * Miscellaneous call actions
 */
export const CUSTOM_PARAMETERS_RECEIVED = callPrefix + 'CUSTOM_PARAMETERS_RECEIVED'
export const GET_AVAILABLE_CODECS = callPrefix + 'GET_AVAILABLE_CODECS'
export const AVAILABLE_CODECS_RETRIEVED = callPrefix + 'AVAILABLE_CODECS_RETRIEVED'

/**
 * Remote operation actions.
 */
export const CALL_REMOTE_HOLD_FINISH = callPrefix + 'REMOTE_HOLD_FINISH'
export const CALL_REMOTE_UNHOLD_FINISH = callPrefix + 'REMOTE_UNHOLD_FINISH'
export const REMOTE_ADD_MEDIA_FINISH = callPrefix + 'REMOTE_ADD_MEDIA_FINISH'
export const REMOTE_REMOVE_MEDIA_FINISH = callPrefix + 'REMOTE_REMOVE_MEDIA_FINISH'
export const REMOTE_START_MOH_FINISH = callPrefix + 'REMOTE_START_MOH_FINISH'
export const REMOTE_STOP_MOH_FINISH = callPrefix + 'REMOTE_STOP_MOH_FINISH'
export const REMOTE_SLOW_START = callPrefix + 'REMOTE_SLOW_START'

/**
 * Turn action types.
 */
const turnPrefix = callPrefix + 'TURN/'

export const TURN_CHANGED = turnPrefix + 'CHANGED'

/**
 * Track action types.
 */
const trackPrefix = callPrefix + 'TRACK/'

export const TRACK_ADDED = trackPrefix + 'ADDED'
export const TRACK_REMOVED = trackPrefix + 'REMOVED'
